// extracted by mini-css-extract-plugin
export default {"head":"head_head__85swe","headtitle":"head_headtitle__Og59T"};